// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.form-template[data-v-09bca518] {\n  display: block;\n  width: 100%;\n}\n.form-template__content-wrapper[data-v-09bca518] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 100%;\n  padding-bottom: 40px;\n}\n.form-template__content-cont[data-v-09bca518] {\n  display: inline-block;\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
